import React from 'react'
import '../../App.css'
import { Layout, Button, Icon } from 'antd';
import footIcon from '../../assets/images/footer-left.png'
import { withTranslation } from 'react-i18next';
import { exeDownUrl, zhupyDownUrl } from '../../utils/config'
const { Footer } = Layout;
const downloadExe = () => {
    let url = window.location.host;
    if (exeDownUrl[url]) {
        window.location.href = exeDownUrl[url]
    } else {
        window.location.href = 'https://es-repo.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe' //'http://es-update.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe'
    }
};
const downloadZhupy = () => {
    let url = window.location.host;
    if (zhupyDownUrl[url]) {
        window.location.href = zhupyDownUrl[url]
    } else {
        window.location.href = 'https://es-repo.digiwincloud.com.cn/installer/Esclient/EsCloudIstall.zip' //'http://es-update.digiwincloud.com.cn/installer/Esclient/EsCloudIstall.zip'
    }
}
let url = window.location.host;
//let dlLocation = 'http://es-ygj.digiwincloud.com.cn'//大陆
let twLocation = "es-ygj.digiwincloud.com"; //台湾
let copy_right = ''
let copy_right_number = ''
class Foot extends React.Component {
    componentDidMount() {
        if (url === twLocation) {
            //copy_right_number:'Copyright © DATA SYSTEMS CO., LTD. All rights reserved.',
            //copy_right: ' 鼎新數智股份有限公司',
            this.copy_right = ' DATA SYSTEMS CO., LTD'
            this.copy_right_number = ' All rights reserved.'
        } else {
            //  copy_right_number:'All rights reserved.沪ICP备10010150号-8',
            //copy_right:' 鼎捷数智股份有限公司',
            this.copy_right = ' 鼎捷数智股份有限公司'
            this.copy_right_number = 'All rights reserved.沪ICP备10010150号-8'
        }
    }
    render() {
        const { t } = this.props
        return (
            <Footer className="q-theme-footer">
                {/* <div className="q-fix-width q-theme-555">
                    <div className="q-content">
                        <div className="q-content-footer-left">
                            <img src={footIcon} alt="" />
                            <div>
                                <h3>{t('captionTw')}</h3>
                                <span>{t('headline')}</span>
                            </div>
                        </div>
                        <div>
                            <Button type="define-button" size="large" onClick={downloadExe}>
                                <Icon type="download" className="f26" />
                                {t('button_download_cloud')}
                            </Button>
                            <Button type="define-button-primary" size="large" style={{ display:'none' }}  onClick={downloadZhupy}>
                                {t('button_download_zhupy')}
                            </Button>
                        </div>
                    </div>
                </div> */}
                <div className="q-copyright tc">
                    {/*<p>Copyright© {t('copy_right')}. {t('copy_right_number')}</p>*/}
                    <p>Copyright© {this.copy_right}. {this.copy_right_number}</p>
                </div>
            </Footer>
        )
    }
}
export default withTranslation()(Foot)